import { render, staticRenderFns } from "./ClientAdminView.vue?vue&type=template&id=465c293d"
import script from "./ClientAdminView.vue?vue&type=script&lang=js"
export * from "./ClientAdminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports